const Surveys = () => import(/* webpackChunkName: "surveys" */ '@/pages/surveys');
const SurveyOverview = () => import(/* webpackChunkName: "surveys" */ '@/pages/surveys/SurveysOverview');
const SurveyCreation = () => import(/* webpackChunkName: "surveys" */ '@/pages/surveys/SurveysCreation');
export default [
  {
    path: 'targetingtools/surveys',
    name: 'Targeting tools / Surveys',
    component: Surveys,
  },
  {
    path: 'targetingtools/surveys/overview/:survey_id?',
    name: 'Targeting tools / Surveys / Overview',
    component: SurveyOverview,
  },
  {
    path: 'targetingtools/surveys/create/:survey_id?/:all_recipients?',
    name: 'Targeting tools / Surveys / Create',
    component: SurveyCreation,
  },
];
